import { ICustomersState } from './customersContext';
import { EntityStatus } from 'types';
import { CustomersActionTypes, TCustomersAction } from './customersActions';

export const customersReducer = (state: ICustomersState, action: TCustomersAction): ICustomersState => {
	switch (action.type) {
		case CustomersActionTypes.SET_CUSTOMERS:
			return {
				...state,
				customers: action.payload.customers,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CustomersActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case CustomersActionTypes.SET_CLIENT_TYPE:
			return {
				...state,
				selectedClientType: action.payload.selectedClientType,
				currentPage: 1,
			};
		case CustomersActionTypes.SET_STATUS:
			return {
				...state,
				status: action.payload.status,
				customers: { customerCount: 0, customers: [] },
				currentPage: 1,
			};
		case CustomersActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				selectedClientType: null,
				status: EntityStatus.Active,
				currentPage: 1,
			};
		case CustomersActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case CustomersActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case CustomersActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case CustomersActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CustomersActionTypes.SET_ID_FOR_ARCHIVING:
			return {
				...state,
				IDForArchiving: action.payload.IDForArchiving,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CustomersActionTypes.SET_ID_FOR_RESTORING:
			return {
				...state,
				IDForRestoring: action.payload.IDForRestoring,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CustomersActionTypes.SET_FULL_INFO_DATA:
			return {
				...state,
				fullInfoData: {
					id: action.payload.fullInfoData?.id,
					activeTab: action.payload.fullInfoData?.activeTab,
				},
			};
		case CustomersActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CustomersActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
